import { EnqueteWelcome } from "../EnqueteCommon";

export function EnqueteIndividuelWelcome(props) {
  return <EnqueteWelcome {...props} pathPrefix="/mandataires/enquetes" />;
}

export default EnqueteIndividuelWelcome;
